import CaseStudyShowcase from './CaseStudyShowcase';

export default CaseStudyShowcase;
export type { ShowcaseItem } from './CaseStudyShowcase';
